'use client';

import { HTMLMotionProps, motion } from 'framer-motion';

export default function AnimatedBlock({ children, ...props }: HTMLMotionProps<'div'>) {
  return <motion.div { ...props }>
    { children }
  </motion.div>;
}
